module.exports = __webpack_public_path__ + "img/section-support.eff9359a.png";